export function isValidEmail(email: string): boolean {
  // source: https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input/email
  const EMAIL_PATTERN =
    /^[\w.!#$%&'*+/=?^`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)*$/i

  return EMAIL_PATTERN.test(email)
}
